"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnabledList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var svgs_1 = require("../assets/svgs");
var Icon = function (_a) {
    var enabled = _a.enabled, notCircled = _a.notCircled;
    return ((0, jsx_runtime_1.jsx)(material_1.ListItemIcon, __assign({ sx: { minWidth: '2.8rem' } }, { children: !notCircled ? ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "span", sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '2.0rem',
                height: '2.0rem',
                borderRadius: '9999px',
                color: 'primary.600',
                backgroundColor: enabled ? 'success.main' : 'error.main',
            } }, { children: enabled ? (0, jsx_runtime_1.jsx)(svgs_1.Check, {}) : (0, jsx_runtime_1.jsx)(svgs_1.Union, {}) }))) : enabled ? ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "span", sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '2.0rem',
                height: '2.0rem',
                borderRadius: '9999px',
                color: 'success.main',
            } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.Check, {}) }))) : ((0, jsx_runtime_1.jsx)(svgs_1.Union, {})) })));
};
var Item = function (_a) {
    var enabledText = _a.enabledText, disabledText = _a.disabledText, enabled = _a.enabled, index = _a.index, notCircled = _a.notCircled;
    return ((0, jsx_runtime_1.jsxs)(material_1.ListItem, __assign({ disableGutters: true, sx: { paddingY: '0.6rem' } }, { children: [(0, jsx_runtime_1.jsx)(Icon, { enabled: enabled, notCircled: notCircled }), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: enabled ? enabledText : disabledText })] }), index));
};
var EnabledList = function (_a) {
    var data = _a.data, _b = _a.name, name = _b === void 0 ? '' : _b, sx = _a.sx;
    return ((0, jsx_runtime_1.jsx)(material_1.List, __assign({ sx: __assign({}, sx) }, { children: data.map(function (item, index) {
            return ((0, jsx_runtime_1.jsx)(Item, { index: "".concat(index, "-").concat(name), enabledText: item.enabledText, disabledText: item.disabledText, enabled: item.enabled, notCircled: item.notCircled }, "".concat(index, "-").concat(name)));
        }) })));
};
exports.EnabledList = EnabledList;
